import { AppFeature } from "../components/AppContext";

export const venueToCardStyle = (venue: AppFeature) => {
    if(venue.properties.venue_type === 'Cafe/Restaurant'){
        return {
            backgroundColor: '#F35EA1',
			color: '#F35EA1',
            fill: '#F35EA1',
            borderTopColor: '#F35EA1'
        }
    }

    if(venue.properties.venue_type === 'Club'){
        return {
            backgroundColor: '#20B1B6',
			color: '#20B1B6',
            fill: '#20B1B6',
            borderTopColor: '#20B1B6'
        }
    }

    if(venue.properties.venue_type === 'Community space/hall'){
        return {
            backgroundColor: '#FC4741',
			color: '#FC4741',
            fill: '#FC4741',
            borderTopColor: '#FC4741'
        }
    }

    if(venue.properties.venue_type === 'Dedicated live music venue'){
        return {
            backgroundColor: '#4ebf8d',
			color: '#4ebf8d',
            fill: '#4ebf8d',
            borderTopColor: '#4ebf8d'
        }
    }

    if(venue.properties.venue_type === 'Festival'){
        return {
            backgroundColor: '#F3AF00',
			color: '#F3AF00',
            fill: '#F3AF00',
            borderTopColor: '#F3AF00'
        }
    }

    if(venue.properties.venue_type === 'Pub/Hotel/Bar'){
        return {
            backgroundColor: '#719eff',
			color: '#719eff',
            fill: '#719eff',
            borderTopColor: '#719eff'
        }
    }

    if(venue.properties.venue_type === 'Theatre or Performing art space'){
        return {
            backgroundColor: '#FF8121',
			color: '#FF8121',
            fill: '#FF8121',
            borderTopColor: '#FF8121'
        }
    }

    return {
        backgroundColor: '#EFEFEF',
        color: '#EFEFEF',
        fill: '#EFEFEF',
        borderTopColor: '#EFEFEF'
    }
}